import { TextField } from '@material-ui/core';
import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import en from '../../../lang/en-us';
import { SubmitButton, SubmitButtonWithLoader } from '../../../lib/Button';
import { UploadFile } from '../../../lib/UploadFileMultiple';
import { HolderStateProps } from './transmission-request-holder';
import { collectDetailsForPreloginTransmission } from '../../../redux-store/actions/link';
import { ActionHeader } from '../../dashboard/makeNct';

const { dashboard, signUp } = en;

interface TransmissionDownloadProps extends RouteComponentProps<any, any, HolderStateProps> {
    children?: JSX.Element;
}

type ImageStateProps = {
    // index: number;
    name: string;
    format: any;
    content: string;
};

function TransmissionRequestPan(props: any) {
    const { pan, email, reqId } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state || !pan || !email) {
            return props.history.replace('/');
        }
    }, []);

    const [images, setImages] = useState<ImageStateProps[]>([
        {
            name: '',
            format: '',
            content: '',
        },
    ]);
    const [pans, setPans] = useState<string[]>(['']);
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [errorsPresent, setErrorsPresent] = useState<boolean>(true);
    const panRegex = new RegExp('^([a-zA-Z]){3}[pP]{1}[a-zA-Z]{1}([0-9]){4}([a-zA-Z]){1}?$');

    const handleSubmit = async (e: any) => {
        let duplicatedPanIndex = pans.findIndex((_deceasedPan) => _deceasedPan === pan);
        if (duplicatedPanIndex !== -1) {
            alert(dashboard.TransmissionRequest.validationError);
            return;
        }

        const content: Array<string> = [];
        let filtered_images = images.filter((image: ImageStateProps) => image.content !== '');
        filtered_images.forEach((image: any) => {
            content.push(image.content);
            delete image.content;
        });
        content.forEach((item: any, index: number) => {
            localStorage.setItem(`deathCertificate${index + 1}`, item);
        });
        let panAlreadyExists = false;
        let dupIndex;
        if (pans.length > 1) {
            pans.forEach((pan: string, index: number) => {
                if (pans.indexOf(pan.toUpperCase()) !== pans.lastIndexOf(pan.toUpperCase())) {
                    panAlreadyExists = true;
                    dupIndex = index + 1;
                }
            });
        }
        if (panAlreadyExists) {
            alert(`Entered Duplicate PAN${dupIndex}`);
            return;
        }
        try {
            let deceasedPans: any = {};
            pans.forEach((pan, index) => {
                deceasedPans[`pan${index + 1}`] = pan.toUpperCase();
            });
            const payload: any = {
                reqId,
                claimantPan: pan,
                ...deceasedPans,
            };
            setSubmitting(true);
            let res = await props.collectDetailsForPreloginTransmission(payload);
            props.history.replace('/links/transmission-request-holder', {
                ...props.location.state,
                images: filtered_images,
                pans: [...pans],
            });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = (index: number): any => {
        setImages((prevImages) => [...prevImages.slice(0, index), ...prevImages.slice(index + 1)]);
        setPans((prevState) => [...prevState.slice(0, index), ...prevState.slice(index + 1)]);
        let errPresent: boolean = false;
        pans.forEach((pan, i) => {
            if (i != index) errPresent = errPresent || !panRegex.test(pan);
        });
        images.forEach((image, i) => {
            if (i != index) errPresent = errPresent || image.content === '';
        });
        setErrorsPresent(errPresent);
    };

    const handleAddPan = () => {
        setImages((prevState) => [...prevState, { name: '', format: '', content: '' }]);
        setPans((prevState) => [...prevState, '']);
        setErrorsPresent(true);
    };

    const consolidateErrors = (index: number, e: any): boolean => {
        let errPresent: boolean = false;
        pans.forEach((pan, i) => {
            errPresent = errPresent || !panRegex.test(i == index ? e.target.value : pan);
        });
        images.forEach((image) => {
            errPresent = errPresent || image.content === '';
        });
        return errPresent;
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.TransmissionRequest.TransmissionUnitHeading} />
            {/* <h2 className="heading">
                <a onClick={() => props.history.goBack()} tabIndex={0}>
                    <img src="/images/left-arrow-black.svg" alt="Back" />
                </a>
            </h2> */}
            <div className="curved-bg-content curved-bg-table-outer transmission-request transmission-download">
                <div className="curved-bg-content-inner">
                    <ul>
                        {images.map((image: any, index: number) => (
                            <li key={index}>
                                <div className="transmission-download-content pan-upload-content">
                                    <div className="transmission-pan-content">
                                        <div className="transmission-dc-upload">
                                            <p>
                                                {dashboard.TransmissionRequest.pan.enterPan}
                                                {index + 1}
                                            </p>
                                            <TextField
                                                variant="outlined"
                                                label={
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .enterPan
                                                }
                                                value={(pans[index] || '').toUpperCase()}
                                                onChange={(e) => {
                                                    setPans((prevPans) => {
                                                        return [
                                                            ...prevPans.slice(0, index),
                                                            e.target.value.toUpperCase(),
                                                            ...prevPans.slice(index + 1),
                                                        ];
                                                    });
                                                    let errPresent: boolean = consolidateErrors(
                                                        index,
                                                        e,
                                                    );
                                                    setErrorsPresent(errPresent);
                                                }}
                                                error={
                                                    !!pans[index] &&
                                                    panRegex.test(pans[index]) === false
                                                }
                                                helperText={
                                                    !!pans[index] &&
                                                        panRegex.test(pans[index]) === false
                                                        ? signUp.form.pan.validations.regexError
                                                        : ''
                                                }
                                            />
                                        </div>
                                        <div className="transmission-dc-upload">
                                            <p>
                                                {dashboard.TransmissionRequest.pan.panUpload}
                                                {index + 1}
                                            </p>
                                            <UploadFile
                                                id={`${index}`}
                                                setSelectedFile={(file: any) => {
                                                    setImages((prevImages) => {
                                                        return [
                                                            ...prevImages.slice(0, index),
                                                            {
                                                                name: file.name,
                                                                content: file.content,
                                                                format: file.format,
                                                            },
                                                            ...prevImages.slice(index + 1),
                                                        ];
                                                    });
                                                    let errPresent: boolean = false;
                                                    images.forEach((image, i) => {
                                                        errPresent =
                                                            errPresent ||
                                                            (i == index ? file : image).content ===
                                                            '';
                                                    });
                                                    pans.forEach((pan) => {
                                                        errPresent =
                                                            errPresent || !panRegex.test(pan);
                                                    });
                                                    setErrorsPresent(errPresent);
                                                }}
                                                selectedFile={{ name: image.name }}
                                                isSelected={image.content === '' ? false : true}
                                            />
                                            {images.length != 1 && (
                                                <a
                                                    onClick={() => {
                                                        handleDelete(index);
                                                    }}
                                                >
                                                    <img
                                                        className="delete-pan-icon"
                                                        src="/images/delete-folio.svg"
                                                        alt=""
                                                    />
                                                </a>
                                            )}
                                            {index == images.length - 1 && images.length < 3 && (
                                                <div className="add-pan">
                                                    <a onClick={handleAddPan}>
                                                        <img src="/images/add-purple.svg" alt="" />
                                                        {dashboard.TransmissionRequest.pan.addPan}
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            label={dashboard.changeEmail.buttonText}
                            disabled={errorsPresent || submitting}
                            onClick={handleSubmit}
                            loading={submitting}
                            labelWhileLoading={'Submitting'}
                        />
                        {/* <SubmitButton
                            label={submitting ? 'Submitting' : dashboard.changeEmail.buttonText}
                            // className="customBtn"
                            disabled={!canSubmit || submitting}
                            onClick={handleSubmit}
                        /> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { collectDetailsForPreloginTransmission })(TransmissionRequestPan);
